export const PASSENGERS_FORM_SECTION = 'passengers';

export const CABIN_CLASS = 'cabinClass';
export const CARRIER_CODES = 'carrierCodes';
export const DIRECT_FLIGHT = 'directFlight';
export const TRIP_TYPE = 'tripType';

export const DESTINATION = 'destination';
export const ORIGIN = 'origin';

export const MULTI_BOUND = 'multiBound';
export const SINGLE_BOUND = 'singleBound';

export const DEPARTURE_DATE = 'departureDate';
export const DEPARTURE_TIME_OF_DAY = 'departureTimeOfDay';

export const RETURN_DATE = 'returnDate';
export const RETURN_TIME_OF_DAY = 'returnTimeOfDay';

export const passengerFields = {
  ADULTS: 'adults',
  CHILDREN: 'children',
  CHILDREN_AGES: 'childrenAges',
  INFANTS: 'infants',
  INFANTS_AGES: 'infantsAges',
} as const;
